<template>
  <div id="my-dialog">
    <div class="content">
      <div class="dialog-title">{{ dialogData.title }}</div>
      <div class="dialog-content customScrollBar">
        <div class="line" v-for="(item, index) in dialogData.data" :key="index">
          <div class="title">
            {{ item.name }}<span v-if="!item.isNull">*</span>
          </div>
          <div class="value" v-if="item.type == 'input'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
              clearable
            ></el-input>
          </div>
          <div class="value" v-if="item.type == 'input_password'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
              show-password
            ></el-input>
          </div>
          <div class="value" v-if="item.type == 'input_password2'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
              show-password
              @blur="inputpassword"
              @focus="focuspassword"
            ></el-input>
          </div>
          <!-- 手机号 -->
          <div class="value" v-if="item.type == 'input_phone'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
              clearable
              @input="input"
            ></el-input>
          </div>
          <!-- 获取手机验证码 -->
          <div class="value" v-if="item.type == 'input-yzm'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
            ></el-input>
            <div v-if="yzm" class="yzm" @click="getCode">获取验证码</div>
            <div v-if="!yzm" class="yzm1">重新发送({{ count }})</div>
          </div>
          <!-- 性别 -->
          <div class="value" v-if="item.type == 'radio'">
            <el-radio-group v-model="item.value">
              <div class="radio_outer">
                <el-radio-button label="男">
                  <div class="el_radio_button_div">男</div>
                </el-radio-button>
                <el-radio-button label="女">
                  <div class="el_radio_button_div">女</div>
                </el-radio-button>
              </div>
            </el-radio-group>
          </div>

          <!-- 多图上传 -->
          <div class="value" v-if="item.type == 'uploadList'">
            <div class="uploadList">
              <div class="uploadList_top">
                <el-upload
                  class="upload-demo"
                  :action="action"
                  :headers="headers"
                  :show-file-list="false"
                  multiple
                  :data="{
                    title: item.uploadTitle,
                    project: '合肥城市学院',
                  }"
                  :before-upload="beforeAvatarUpload"
                  :on-success="handleAvatarSuccess"
                  ><el-button size="mini" type="primary">点击上传</el-button>
                </el-upload>
                <div class="uploadList_top_tip">
                  只能上传jpg/jpeg/png/pdf文件,且不超过5MB
                </div>
              </div>
              <div class="upBox">
                <div
                  class="upBox_children"
                  v-for="(it, ii) in item.fileList"
                  :key="ii"
                >
                  <span @click="openImg(it)" class="upBox_children_word">
                    {{ it.name }}</span
                  >
                  <span
                    class="error"
                    @click.stop="deleteUpImg(item.fileList, ii)"
                    ><i class="el-icon-close"></i
                  ></span>
                </div>
              </div>
            </div>
          </div>

          <!-- 身份证照片 -->
          <div class="value" v-if="item.type == 'idcardImg'">
            <div class="idcardImg">
              <div class="idcardImgBox_outer">
                <div
                  class="idcardImgBox"
                  v-for="(it, i) in item.idcardImgLIst"
                  :key="i"
                >
                  <el-upload
                    v-if="it.pathflag == 0"
                    class="avatar-uploader"
                    :action="action"
                    :show-file-list="false"
                    :headers="headers"
                    multiple
                    :data="{
                      title: item.uploadTitle,
                      project: '合肥城市学院',
                    }"
                    :on-success="
                      (response, file, fileList) => {
                        handleAvatarSuccess(response, file, fileList, i);
                      }
                    "
                    :before-upload="beforeAvatarUpload"
                  >
                    <span class="idcardImgBox_info">{{ it.info }}</span>
                    <div class="idcardImgBox_upload">
                      <img :src="it.path" alt="" object-fi="contain" />
                    </div>
                  </el-upload>
                  <div v-else style="height: 100%">
                    <div
                      class="idcardImgBox_upload"
                      v-if="it.pathflag == 1"
                      v-viewer="{ movable: false }"
                    >
                      <img :src="it.path" alt="" object-fi="contain" />
                    </div>
                    <div
                      class="img-delete"
                      @click.stop="deleteImg(item.idcardImgLIst, i)"
                    >
                      <i class="el-icon-delete"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-but">
          <div
            class="valuebtn"
            v-for="(item, index) in dialogData.btns"
            :key="index"
            @click="handleClick(item.active)"
          >
            <span>{{ item.btnName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "my_dialog",
  props: {
    myDialogData: {
      type: Object,
      default: function () {
        return {
          flag: true,
          title: "注册",
          data: [],
        };
      },
    },
  },
  data() {
    return {
      dialogData: this.myDialogData,
      // dialogData.suo: true, //获取验证码
      timeCont: 60,
      yzm: true, //
      timer: 0,
      count: 0,

      headers: {
        token: this.$token,
      },
      action: this.$baseurl + "/uploadFile",
      showFile: false,
      fileName: "",
    };
  },
  methods: {
    editPsw() {
      this.$emit("editPsw");
    },
    handleClick(active) {
      this.$emit("handleClick", active);
    },
    /* 输入手机号时显示发送验证码 */
    input() {
      for (let index = 0; index < this.dialogData.data.length; index++) {
        const element = this.dialogData.data[index];
        if (element.key == "phone" && element.value == "") {
          this.yzm = false;
        }
        if (element.key == "phone" && element.value != "") {
          this.yzm = true;
        }
      }
    },

    /* 发送验证码 */
    getCode() {
      for (let index = 0; index < this.dialogData.data.length; index++) {
        const element = this.dialogData.data[index];
        let requestData = {
          phone: "",
        };
        if (element.key == "phone") {
        }
        if (element.key == "phone" && element.value == "") {
          this.$message.error("手机号填写不能为空!");
          return;
        }
        if (
          element.key == "phone" &&
          !this.$mobilePhoneNumberCheck.mobilePhoneNumberCheck(element.value)
        ) {
          this.$message.error("请填写正确格式的手机号!");
          return;
        }
        if (element.key == "phone") {
          requestData.phone = element.value;
          if (!this.timer) {
            console.log(this.timer);
            this.count = 60;
            this.yzm = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= 60) {
                this.count--;
              } else {
                this.yzm = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          this.$request(
            "post",
            "/sendVerificationCode",
            requestData,
            (data) => {
              //获取到手机验证码,1.页面控制,一分钟只能点一次
              this.dialogData.suo = false;
              this.$message({
                message: "已发送验证码,注意查收!",
                type: "success",
              });
            }
          );
        }
      }
    },
    /* 手机号校验 */

    inputpassword() {
      this.$emit("inputpassword");
    },
    focuspassword() {
      this.$emit("focuspassword");
    },
    /**
     * 图片上传前的校验
     */
    beforeAvatarUpload(file) {
      console.log(file);
      let isJPG =
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/pdf";
      if (!isJPG) {
        this.$message.error("上传图片只能是 jpg 格式或 png 格式!");
      }
      return isJPG;
    },
    handleAvatarSuccess(response, file, fileList, imgIndex) {
      console.log("上传图片", response, file, fileList);
      // 判断上传的文件是什么格式
      let path = response.result.path;

      let name = response.result.name;

      let title = response.result.title;

      this.showFile = true;

      for (let index = 0; index < this.dialogData.data.length; index++) {
        const element = this.dialogData.data[index];

        if (element.key == "statusCheckFile" && title == "学籍资料审核表") {
          console.log("wqeqqweqeq", element);
          let obj = {
            name: name,
            path: path,
          };
          element.fileList.push(obj);
          console.log(" element.fileList", element.fileList);
        }
        if (element.key == "stuStatusFile" && title == "所在学校学籍表") {
          let obj = {
            name: name,
            path: path,
          };

          element.fileList.push(obj);
        }
        if (element.key == "withoutTestFile" && title == "免试") {
          let obj = {
            name: name,
            path: path,
          };

          element.fileList.push(obj);
          console.log(0);
        }
        if (element.key == "otherScoreFile" && title == "加分") {
          let obj = {
            name: name,
            path: path,
          };

          element.fileList.push(obj);
        }
        if (element.key == "idCardFile" && title == "身份证图片") {
          console.log(element);
          let obj = {
            path: "",
            pathflag: 1,
            idCardflag: "1",
          };
          obj.path = path;
          element.idcardImgLIst.splice(imgIndex, 1, obj);
          if (imgIndex == 1) {
            element.idCardflag = "1";
          }
        }
      }
    },

    //删除上传的文件(如学籍表,审核表)
    deleteUpImg(arr, index) {
      arr.splice(index, 1);
    },
    //打开上传图片的连接
    openImg(it) {
      window.open(it.path, "_blank");
    },

    /* 删除身份证照片 */
    deleteImg(arr, ind) {
      console.log("121312312313131", arr);
      for (let index = 0; index < arr.length; index++) {
        arr[ind].path = "";
        if (ind == 0) {
          arr[ind].path = require("../../assets/img/sfzf.png");
          arr[ind].info = "点击上传身份证人像面图片";
          arr[ind].pathflag = 0;
        }
        if (ind == 1) {
          arr[ind].path = require("../../assets/img/sfzz.png");
          arr[ind].info = "点击上传身份证国徽面图片";
          arr[ind].pathflag = 0;
        }
      }
    },

    handleBeforePreview(file) {
      console.log("100000", file);
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
#my-dialog {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .dialog-title {
      font-size: 14px;
    }
    .dialog-content {
      width: 100%;
      flex: 1;
      box-sizing: border-box;
      padding: 0 20px;
      .line {
        width: 100%;
        min-height: 4.625rem;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 10px;
        .title {
          font-size: 14px;
          > span {
            color: red;
          }
        }
        .value {
          width: 100%;
          min-height: 43px;
          height: auto;
          position: relative;
          display: flex;
          align-items: center;
          .yzm {
            position: absolute;
            right: 10px;
            top: 12px;
            color: rgba(0, 79, 148, 1);
            font-size: 14px;
            font-weight: 400;
            &:hover {
              cursor: pointer;
              color: rgb(7, 132, 241);
            }
          }
          .yzm1 {
            position: absolute;
            right: 10px;
            top: 12px;
            color: #7e7c7c;
            font-size: 14px;
            font-weight: 400;
          }
          .radio_outer {
            width: 50%;
            display: flex;
          }
          .el_radio_button_div {
            width: 100px;
            border-radius: 7px;
          }
          .uploadList {
            width: 100%;
            height: 100%;
            border-radius: 12px;
            background: rgba(247, 247, 247, 1);
            display: flex;
            flex-direction: column;
            padding: 2px 5px;
            box-sizing: border-box;
            align-items: flex-start;
            .uploadList_top {
              width: 100%;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .upPrompt {
                font-size: 10px;
                margin-left: 10px;
              }
              .uploadList_top_tip {
                font-size: 10px;
                margin-left: 10px;
              }
            }
            .upBox {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              // justify-content: space-between;
              align-items: center;
              padding: 2px 5px;
              margin-bottom: 5px;
              box-sizing: border-box;
              .upBox_children {
                // width: 50%;
                display: flex;
                font-size: 10px;
                margin: 0 10px 10px 0;

                .upBox_children_word {
                  &:hover {
                    text-decoration: underline;
                    cursor: pointer;
                  }
                }

                &:hover .error {
                  color: red;
                  text-decoration: none;
                  cursor: pointer;
                }
                .error {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 10px;
                  height: 10px;
                  font-size: 2px;
                  // color: red;
                  color: rgba(247, 247, 247, 1);
                  margin-left: 10px;
                }
              }
            }
            > span {
              font-size: 12px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
            }
            > img {
              width: 12px;
              height: 12px;
            }
            .file {
              font-size: 14px;
              letter-spacing: 1px;
              text-align: left;
            }
          }
          .upload-demo {
            width: 0 !important;
          }
          .idcardImg {
            width: 100%;

            display: flex;
            justify-content: space-between;

            .idcardImgBox_outer {
              width: 100%;
              display: flex;
              justify-content: space-between;
              .idcardImgBox {
                width: 45%;
                border-radius: 12px;
                background: rgba(247, 247, 247, 1);
                position: relative;
                // > .idcardImgBox_info {
                //   font-size: 10px;
                //   font-weight: 400;
                //   color: rgba(128, 128, 128, 1);
                // }
                /deep/ .el-upload.el-upload--text {
                  font-size: 12px;
                }
              }
            }

            .idcardImgBox_view_outer {
              width: 100%;

              display: flex;
              justify-content: space-between;

              .idcardImgBox_view {
                width: 45%;
                border-radius: 12px;
                background: rgba(247, 247, 247, 1);
                position: relative;
              }
            }
            .idcardImgBox_upload {
              width: 100%;
              height: 100%;
              position: absolute;

              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              align-items: center;
              border-radius: 7px;
              position: relative;
              > img {
                width: 160px;
                height: 111px;
              }
            }
            .img-delete {
              width: 100%;
              height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              left: 0;
              bottom: 0;
              opacity: 0;
              transition: 0.3s;
              background-color: #0a09093d;
              color: #fff;
              &:hover {
                cursor: pointer;
                opacity: 1;
              }
            }
          }
        }
      }
      .dialog-but {
        width: 100%;
        height: 2.8125rem;
        box-sizing: border-box;
        margin-top: 20px;
        border-radius: 50px;
        .valuebtn {
          width: 100%;
          height: 43px;
          background: rgba(7, 80, 139, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          &:hover {
            cursor: pointer;
          }
          > span {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
